import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'dva';
import Header from 'components/Header';
import Footer from 'components/Footer';
import styles from './index.less';
import { dateFormat } from 'utils';
import iconCancel from 'images/cancelState.png';
import imgDivider from 'images/recordLine.png';
import bgHeader from 'images/bg_header_cip.png';
import iconEnter from 'images/ico_enter_grey@2x.png';
import router from 'umi/router';
const checkCancelState = (state) => {
  return String(state) === '-1';
};
const RecordListPage = (props) => {
  const dispatch = useDispatch();
  const { cipInfo = {} } = useSelector((state) => state.cip) || {};
  const query = props.location.query || {};
  const { cipId } = query;
  const hasCipId = !!cipId; // 有了这个id不能选择机场和出发类型
  const [recordState, setRecordState] = useState('1'); // 1正常， -1取消状态

  useEffect(() => {
    if (Object.keys(cipInfo).length > 0) {
      return;
    }
    dispatch({
      type: 'cip/getCipInfo',
      callback: (res) => {},
    });
  }, []);
  console.log(dateFormat, 'datefor');
  const handleActiveTab = useCallback((state) => {
    setRecordState(state);
  });
  const filterList = useMemo(
    () =>
      (cipInfo.recordList || []).filter((item) => {
        return String(item.state) === recordState;
      }),
    [cipInfo.recordList, recordState],
  );
  // const filterList = (cipInfo.recordList || []).filter((item) => {
  //   return String(item.state) === recordState;
  // });
  const isCancel = recordState === '-1';
  const TabList = [
    { label: '已使用', key: '1' },
    { label: '已取消', key: '-1' },
  ];
  return (
    <div className={styles.recordListPage}>
      <Header title={`快速安检`} showHome={false} />

      <div className={styles.tabs}>
        {TabList.map((item) => (
          <div
            className={`${styles.tab} ${recordState === item.key ? styles.active : ''}`}
            key={item.key}
            onClick={handleActiveTab.bind(null, item.key)}
          >
            <span className={styles.tabText}>{item.label}</span>
            {recordState === item.key && <div className={styles.line}></div>}
          </div>
        ))}
        {/* <div
          className={`${styles.tab}  ${isCancel ? styles.active : ''}`}
          onClick={handleActiveTab.bind(null, '-1')}
        >
          已取消
        </div> */}
      </div>
      <div className={styles.content}>
        {filterList.map((item) => (
          <div className={styles.box}>
            <div className={styles.title}>
              <div className={styles.left}>{item.airportName}</div>
              <div style={{ color: isCancel ? '#9B9B9B' : '#222' }}>
                <span style={{ color: isCancel ? '#9B9B9B' : '#F34242' }}>
                  {Math.abs(Number(item.personcount))}
                </span>
                人次
              </div>
            </div>
            <div className={styles.textRow}>使用网点：{item.cipName}</div>
            <div className={styles.textRow}>服务订单：{item.orderCode}</div>
            <img src={imgDivider} style={{ width: '100%' }} alt="" />
            <div className={styles.foot}>
              使用时间：{dateFormat('YYYY-mm-dd HH:MM:SS', item.time)}
              {!isCancel && <span style={{ color: '#F34242' }}>已使用</span>}
            </div>
            {isCancel && <img className={styles.cancelState} src={iconCancel} />}
          </div>
        ))}
        {filterList.length === 0 && <div className={styles.noRecord}>暂无数据</div>}
      </div>
    </div>
  );
};

export default RecordListPage;
